import React, { useState, useEffect } from "react";
import "./EditCustomer.css";
import { AiOutlineClose } from "react-icons/ai";
import Popup from "../../components/ui/Popup"; // ✅ Import Popup Component

function EditCustomer({ isOpen, customer, onClose, onSave }) {
    const [formData, setFormData] = useState({
        nic: "",
        firstName: "",
        lastName: "",
        dob: "",
        gender: "Male",
        address: "",
        contactNumber: "",
    });

    const [popupMessage, setPopupMessage] = useState(""); // ✅ Success/Error message state
    const [popupType, setPopupType] = useState(""); // ✅ "success" or "error"

    useEffect(() => {
        if (customer) {
            setFormData({
                nic: customer.NIC || customer.nic || "",
                firstName: customer.FirstName || "",
                lastName: customer.LastName || "",
                dob: customer.DOB ? customer.DOB.split("T")[0] : "",
                gender: customer.Gender || "Male",
                address: customer.Address || "",
                contactNumber: customer.ContactNumber || "",
            });
        }
    }, [customer]);

    if (!isOpen) return null;

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSave = async () => {
        try {
            await onSave(formData);
            setPopupMessage("Customer details updated successfully!"); // ✅ Show success message
            setPopupType("success");

            setTimeout(() => {
                setPopupMessage("");
                onClose(); // ✅ Close modal after success
            }, 2000);
        } catch (error) {
            setPopupMessage("Failed to update customer details!"); // ✅ Show error message
            setPopupType("error");
        }
    };

    return (
        <div className="customer-popup-secondary">
            <div className="customer-popup-content">
                <button className="customer-close-btn" onClick={onClose}>
                    <AiOutlineClose />
                </button>
                <h2>Edit Customer</h2>
                <div className="popup-divider"></div>

                {/* ✅ Popup for Success/Error Messages */}
                <Popup message={popupMessage} type={popupType} onClose={() => setPopupMessage("")} />

                <form className="edit-customer-form">
                    <div className="form-group">
                        <label>NIC:</label>
                        <input type="text" name="nic" value={formData.nic} disabled />
                    </div>

                    <div className="form-row">
                        <div className="form-group">
                            <label>First Name:</label>
                            <input type="text" name="firstName" value={formData.firstName} onChange={handleChange} />
                        </div>
                        <div className="form-group">
                            <label>Last Name:</label>
                            <input type="text" name="lastName" value={formData.lastName} onChange={handleChange} />
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="form-group">
                            <label>DOB:</label>
                            <input type="date" name="dob" value={formData.dob} onChange={handleChange} />
                        </div>
                        <div className="form-group">
                            <label>Gender:</label>
                            <select name="gender" value={formData.gender} onChange={handleChange}>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                            </select>
                        </div>
                    </div>

                    <div className="form-group">
                        <label>Address:</label>
                        <input type="text" name="address" value={formData.address} onChange={handleChange} />
                    </div>

                    <div className="form-group">
                        <label>Contact:</label>
                        <input type="text" name="contactNumber" value={formData.contactNumber} onChange={handleChange} />
                    </div>

                    <button type="button" className="customer-save-btn" onClick={handleSave}>
                        Save Changes
                    </button>
                </form>
            </div>
        </div>
    );
}

export default EditCustomer;
